import React, { Component } from 'react'
import Navbar from '../Components/NavBar'
import UniversitiesLanding from '../Components/UniversitiesLanding'
import Footer from '../Components/Footer'

export class UniversitiesPage extends Component {
  render() {
    return (
      <div>
        <Navbar/>
        <UniversitiesLanding/>
        <Footer/>
      </div>
    )
  }
}

export default UniversitiesPage
